var map = {
	"./arrow_down.svg": 6988,
	"./black_logo.svg": 9843,
	"./easy.svg": 3676,
	"./facebook.svg": 6338,
	"./female.svg": 5690,
	"./info.svg": 4646,
	"./instagram.svg": 1574,
	"./linkedin.svg": 7464,
	"./list.svg": 7050,
	"./logo.svg": 3935,
	"./male.svg": 4693,
	"./mobile_black_logo.svg": 8782,
	"./mobile_logo.svg": 3826,
	"./payment.svg": 9576,
	"./play_button.svg": 2599,
	"./power.svg": 4769,
	"./strike.svg": 9672,
	"./warranty.svg": 1334,
	"./whatsapp.svg": 6144,
	"./x.svg": 698,
	"./youtube.svg": 8549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;